import React from 'react';

import {
  CardsContainer,
  CardWrapper,
  Card,
  CardTitle,
  CardDescription,
  IconContainer,
  CardHoverIconContainer
} from './ServiceTypeCards.styled';
import FertilityDecorativeIcon from 'assets/icons/fertility-decorative.svg?react';
import HolisticHealthDecorativeIcon from 'assets/icons/holistic-health-decorative.svg?react';

interface ServiceTypeCardsProps {
  onFertilityClick?: () => void;
  onHolisticClick?: () => void;
}

export const ServiceTypeCards = ({
  onFertilityClick,
  onHolisticClick
}: ServiceTypeCardsProps): JSX.Element => {
  return (
    <CardsContainer data-testid="service-options-container">
      <CardWrapper>
        <Card onClick={onFertilityClick} type="button">
          <IconContainer>
            <FertilityDecorativeIcon />
          </IconContainer>
          <CardHoverIconContainer>
            <FertilityDecorativeIcon />
          </CardHoverIconContainer>
          <CardTitle>Fertility</CardTitle>
          <CardDescription>
            Conception, Family-building care, Freezing eggs or embryos
          </CardDescription>
        </Card>
      </CardWrapper>
      <CardWrapper>
        <Card onClick={onHolisticClick} type="button">
          <IconContainer>
            <HolisticHealthDecorativeIcon />
          </IconContainer>
          <CardHoverIconContainer>
            <HolisticHealthDecorativeIcon />
          </CardHoverIconContainer>
          <CardTitle>Holistic Health</CardTitle>
          <CardDescription>
            Holistic family care and planning, Pregnancy support, General wellbeing
          </CardDescription>
        </Card>
      </CardWrapper>
    </CardsContainer>
  );
};
